import { useMutation } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';

interface Payload {
  clientEmailAddress: string;
  clientName: string;
  clientPhoneNumber?: string;
  agentEmailAddress: string;
  agentName: string;
  propertyAddress: string;
  propertyId: string;
  additionalInfo?: string;
  helpNeeded: string[];
}

export default function useRequestHelp() {
  const token = window.localStorage.getItem('_token');

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/common/email/help`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
  });
}
